import { render } from "./FormAgenda.vue?vue&type=template&id=7a8868c4"
import script from "./FormAgenda.vue?vue&type=script&lang=js"
export * from "./FormAgenda.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__